import React from 'react';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { checkCurrentOrBeforeDate, getUpdatedSelection, checkEditPermission, isFirefox } from '../../../Utils/helper';
import { buildCellData, handleCellContextMenu, cellHasRemarks, getCellDataAttributes } from '../../../Utils/cellRemarkHelper';

const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

export const renderProductData = (nextDate, productSalesHeader, inoutData,
  isEditing,
  updateId,
  updateDate,
  updateProduct, updateValue, setIsEditing,
  setUpdateValue, setUpdateId, setUpdateDate, setUpdateProduct, updateReserveData, showGroupData, selectedGroupProducts, tooltipPosition, setTooltipPosition, formattedDate, setProductLabelModal, productLabelModal, setLabelData, labelData, setSubGroup, setGroupName, setProductName, setLabelDate, inputRefs, flatInputIndex, loader, setGroupProductIds, setModalInputDisabled, setSubGroupName, rolesData, rowIndex, columnCounter, selectedCell, setSelectedCell, selectedCellsForSum, setSelectedCellsForSum, inputValues, convertOutInputs, setConvertOutInputs, debouncedUpdateConvertOutData,setContextMenu, setSelectedCellData, cellRemarks, onEditActualStock, hiddenReserveGroups) => {

  const productId = productSalesHeader.productGroupOriginalId;
  const reserveData = inoutData?.sectionReserves?.product?.data?.[productId] || {};
  const arrivalData = inoutData?.sectionArrivals?.product?.data?.[productId] || {};

  const customerGroups = reserveData || arrivalData || {}; // default to empty object
  const isFromReserve = !!reserveData;
  const convertOutsObject = inoutData?.convertOuts?.product?.data?.[productId]?.[formattedDate] || {};
  const convertOutsHistoryObject = inoutData?.convertOuts?.product?.history?.[productId]?.[formattedDate] || {};
  const firstFinishPid = Object.keys(productSalesHeader?.finishedProductCodes || {})[0];

  const totalConvertOutQuantity = Object.values(convertOutsObject).reduce((sum, item) => sum + (item || 0), 0);
  const displayConvertInQuantity = inoutData?.convertIns?.product?.data?.[productId]?.[formattedDate] || '';
  const arrivalDataForDate = productSalesHeader?.arrivalData?.[formattedDate] || [];
  const totalArrivalQuantity = arrivalDataForDate.reduce((sum, item) => sum + (item?.arrival || 0), 0);
  const arrivalHistoryValue = productSalesHeader?.arrivalHistory?.[formattedDate]?.history;
  const displayArrivalQuantity = arrivalHistoryValue !== undefined
    ? `${arrivalHistoryValue} -> ${totalArrivalQuantity}`
    : totalArrivalQuantity > 0 ? totalArrivalQuantity : '';

  const inventoryForDate = Object.values(productSalesHeader?.inventoryData?.data || {}).find(
    data => data?.date === nextDate
  );
  const estimatedStock = inventoryForDate?.estimated || 0;
  const actualStock = inventoryForDate?.actual || 0;
  const inventoryStatus = inventoryForDate?.status;
  const isCurrentOrBeforeDate = checkCurrentOrBeforeDate(nextDate);

  return (
    <>
    {/* //arrival qty cell block */}
      {(() => {
        const thisCol = columnCounter.value++;
        const key = `${rowIndex}-${thisCol}`;
        const isSelected = selectedCellsForSum[key] !== undefined;

        const handleClick = () => {
          setSelectedCell({ row: rowIndex, col: thisCol });

          if (displayArrivalQuantity == '') {
            return;
          }
          const newSelection = getUpdatedSelection(
            selectedCellsForSum,
            rowIndex,
            thisCol,
            Number(totalArrivalQuantity) || 0
          );
          setSelectedCellsForSum(newSelection);
        };

        const arrivalQtyCellData = buildCellData({
          cellType: 'arrival_qty',
          date: formattedDate,
          module: 'inout',
          productId: productId,
          productName: productSalesHeader?.productGroupId || 'N/A',
        });
        const hasRemarksArrivalQty = cellHasRemarks(arrivalQtyCellData, cellRemarks);

        return (
          <td 
            onClick={handleClick} 
            onContextMenu={(e) => {
              handleCellContextMenu(e, arrivalQtyCellData, setContextMenu, setSelectedCellData);
            }}
            {...getCellDataAttributes(arrivalQtyCellData)}
            className={`arrival-bg fw-bold arival-qty-ui remark-enabled-cell ${hasRemarksArrivalQty ? 'cell-with-remark' : ''} ${displayArrivalQuantity !== '' ? 'show-sum-checkbox' : ''} ${isSelected ? "selected-for-sum" : ""} ${selectedCell.row === rowIndex || selectedCell.col === thisCol
            ? "highlight-border"
            : ""
            }`} 
          >
            <div className="flex ">
              {displayArrivalQuantity !== '' && <div className="grouping">
                <label className="checbox-cs relative cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleClick();
                    }}
                    className="cursor-pointer absolute opacity-0 w-0 h-0"
                  />
                  <span className="checkmark" onClick={(e) => e.stopPropagation()} ></span>
                </label>{" "}
                <span className="ml-1">{displayArrivalQuantity}</span>
              </div>}
            </div>
          </td>
        );
      })()}
      <React.Fragment key={`product-${productId}`}>
        {customerGroups && typeof customerGroups === 'object' &&
          Object.entries(customerGroups).flatMap(([customerGroupLabel, customerSubGroups]) => {
            if (!customerSubGroups || typeof customerSubGroups !== 'object') return [];
            return Object.entries(customerSubGroups).map(([customerSubGroupId, dates]) => {
              if (!dates || typeof dates !== 'object') return null;
              
              const dateKey = Object.keys(dates)[0];
              const firstDateEntry = dates[dateKey]?.[0];
              const customerSubGroupName = firstDateEntry?.customer_sub_group_name || 'N/A';
              const quantitys = dates[nextDate] || [];
              const historyValue = inoutData?.sectionReserves?.product?.history?.[productId]?.[customerGroupLabel]?.[customerSubGroupId]?.[nextDate]?.history;

              const subGroupNameid = firstDateEntry?.customer_sub_group_id || 'N/A';
              const groupName = firstDateEntry?.customer_group_id || 'N/A';
              const productName = firstDateEntry?.product_id || 'N/A';
              const combinedKey = `${subGroupNameid}-${groupName}-${productName}-${nextDate}`
              const unitPrice = (inoutData?.sectionReserves?.product?.data?.[productId]?.[customerGroupLabel]?.[customerSubGroupId]?.[nextDate] || [])
                .map(item => item.unit_price)
                .filter(item => item !== undefined && item !== null)
                .join(', ');
              const quantity =
                quantitys?.length === 0
                  ? {
                    customer_group_name: groupName,
                    customer_sub_group_name: subGroupNameid,
                    product_name: productName,
                    date: nextDate,
                    type: 'product',
                  }
                  : quantitys;

              const checkCustomerGroup = inoutData?.customerGroupsV2?.[firstDateEntry?.customer_group_label]?.[subGroupNameid];

              const getFilteredDataByDate = (inoutData, targetDate, label) => {
                const resultArray = [];

                if (!inoutData?.sectionReserves?.product?.data || typeof inoutData.sectionReserves.product.data !== 'object') {
                  return resultArray;
                }

                const productData = inoutData.sectionReserves.product.data;

                for (const [productId, labledSubGroups] of Object.entries(productData)) {
                  if (!labledSubGroups || typeof labledSubGroups !== 'object') continue;

                  const customerGroupResult = {
                    groupLabel: checkCustomerGroup,
                    subGroups: []
                  };

                  for (const [customerGroupLabel, subGroups] of Object.entries(labledSubGroups)) {
                    if (label && customerGroupLabel !== label) continue;
                    if (!subGroups || typeof subGroups !== 'object') continue;
                    for (const [subGroupId, entriesByDate] of Object.entries(subGroups)) {
                      if (subGroupNameid && entriesByDate[targetDate]?.[0]?.customer_sub_group_id !== subGroupNameid) continue;
                      if (entriesByDate[targetDate] && Array.isArray(entriesByDate[targetDate])) {
                        customerGroupResult.subGroups.push(...entriesByDate[targetDate])
                      };
                    }
                  }

                  resultArray.push(customerGroupResult);
                }

                return resultArray;
              };

              const filteredData = getFilteredDataByDate(inoutData, nextDate, firstDateEntry?.customer_group_label);
              let quantityValue = 0;
              let quantityId = null;
              let currentValue = 0;

              if (Array.isArray(quantitys)) {
                const totalQuantity = quantitys.reduce((sum, q) => sum + (q?.quantity || 0), 0);
                const hasImported = quantitys.some(q => q?.is_imported === 1);
                quantityValue =
                  historyValue !== undefined
                    ? `${historyValue} -> ${totalQuantity}`
                    : totalQuantity > 0
                      ? hasImported ? `0 -> ${totalQuantity}` : totalQuantity
                      : totalQuantity;
                currentValue = quantitys.reduce((sum, q) => sum + (q?.quantity || 0), 0);
                quantityId = quantitys[0]?.id;
              } else if (quantitys?.quantity !== undefined) {
                if (historyValue !== undefined) {
                  quantityValue = `${historyValue} -> ${quantitys.quantity}`;
                } else {
                  quantityValue = quantitys.quantity !== undefined
                    ? `0 -> ${quantitys.quantity}`
                    : quantitys.quantity;
                }
                currentValue = quantitys.quantity;
                quantityId = quantitys.id;
              }
              const currentInputIndex = flatInputIndex.current++;
              const shouldOpenModal = (checkCustomerGroup?.length || 0) > 1 || (dates[nextDate]?.length || 0) > 1;
              if (!isFromReserve) return null;
              const thisCol = columnCounter.value++;
              
              // If reserve is hidden for this product group, render invisible placeholder
              const isReserveHidden = hiddenReserveGroups?.has(productSalesHeader?.productGroupOriginalId);
              if (isReserveHidden) {
                return <td key={`sales-p-hidden-${productId}-${customerGroupLabel}-${customerSubGroupId}`} style={{ display: 'none' }} />;
              }
              
              const reserveCellData = buildCellData({
                cellType: 'sales_reserve',
                date: formattedDate,
                module: 'inout',
                productId: productId,
                customerGroupId: groupName,
                customerSubGroupId: subGroupNameid,
                productName: productSalesHeader?.productGroupId || 'N/A',
                reserveLabel: customerGroupLabel,
              });
              const hasRemarksReserve = cellHasRemarks(reserveCellData, cellRemarks);
              
              return (
                <td 
                  key={`sales-p-${productId}-${customerGroupLabel}-${customerSubGroupId}`} 
                  onClick={() => setSelectedCell({ row: rowIndex, col: thisCol })}
                  onContextMenu={(e) => {
                    handleCellContextMenu(e, reserveCellData, setContextMenu, setSelectedCellData);
                  }}
                  {...getCellDataAttributes(reserveCellData)}
                  className={`sales-bg remark-enabled-cell ${hasRemarksReserve ? 'cell-with-remark' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol
                  ? "highlight-border"
                  : ""
                  }`}
                   onMouseEnter={(e) => {
                    const hasUnitPrice = unitPrice && unitPrice !== '';
                    const hasPromotion = Array.isArray(quantitys)
                      ? quantitys[0]?.promotion_type !== undefined && quantitys[0]?.promotion_type !== null
                      : quantitys?.promotion_type !== undefined && quantitys?.promotion_type !== null;

                    if (hasUnitPrice || hasPromotion) {
                      const rect = e.currentTarget.getBoundingClientRect();
                      const promotionType = hasPromotion ? {
                        promotion_type: Array.isArray(quantitys)
                          ? quantitys[0]?.promotion_type
                          : quantitys?.promotion_type,
                        product_name: firstDateEntry?.product_name_tc,
                        product_date: nextDate
                      } : null;

                      setTooltipPosition({
                        visible: true,
                        x: rect.right + 10,
                        y: rect.top,
                        unitPriceValue: hasUnitPrice ? unitPrice : null,
                        promotionType: promotionType,
                        content: promotionType
                      });
                    }
                  }}
                  onMouseLeave={() => {
                    setTooltipPosition({
                      visible: false,
                      promotionType: null,
                      unitPriceValue: null,
                      content: null,
                      x: 0,
                      y: 0
                    });
                  }}
                >
                  <input
                    type="text"
                    ref={(el) => {
                      if (el) inputRefs.current[currentInputIndex] = el;
                    }}
                    data-index={currentInputIndex}
                    tabIndex={currentInputIndex}
                    className={`inout-tab ${(Array.isArray(quantitys)
                      ? quantitys[0]?.promotion_type !== undefined && quantitys[0]?.promotion_type !== null
                      : quantitys?.promotion_type !== undefined && quantitys?.promotion_type !== null)
                      ? 'highlight'
                      : ''
                      } ${(Array.isArray(quantitys) ? quantitys.some(q => q.is_batch_updated) : quantitys.is_batch_updated) ? 'text-batch-updated' : ''}`}
                    value={(() => {
                      const inputKey = `${rowIndex}-${thisCol}`;
                      const inputValue = inputValues[inputKey];
                      const isCurrentlyEditing = isEditing === quantityValue && updateId === quantityId && updateDate === nextDate && updateProduct === combinedKey;
                      
                      let finalValue = inputValue !== undefined
                        ? inputValue
                        : isCurrentlyEditing
                          ? updateValue
                          : quantityValue === 0
                            ? ''
                            : quantityValue;
                      
                      if (isCurrentlyEditing && typeof finalValue === 'string' && finalValue.includes('->')) {
                        const parts = finalValue.split('->');
                        finalValue = parts[parts.length - 1].trim();
                      }
                      
                      return finalValue;
                    })()}
                    onClick={() => {

                      if (!checkEditPermission(rolesData?.permissions, 'direct_in_out')) {
                        return;
                      }
                      setIsEditing(quantityValue);
                      const existingValue = inputValues[`${rowIndex}-${thisCol}`];
                      let valueToSet = existingValue !== undefined ? existingValue : (currentValue > 0 ? currentValue : '');
                      
                      // If the value has history format, extract just the numeric part for editing
                      if (typeof valueToSet === 'string' && valueToSet.includes('->')) {
                        const parts = valueToSet.split('->');
                        valueToSet = parts[parts.length - 1].trim();
                      }
                      
                      setUpdateValue(valueToSet);
                      setUpdateId(quantityId);
                      setUpdateDate(nextDate);
                      setUpdateProduct(combinedKey);
                      setGroupProductIds(productId)
                      if (shouldOpenModal) { setProductLabelModal(true); setLabelData(filteredData); setSubGroup(subGroupNameid); setSubGroupName(customerSubGroupName); setProductName(productName); setLabelDate(nextDate); setModalInputDisabled(isCurrentOrBeforeDate); }
                    }}
                    onChange={(e) => {
                      updateReserveData(Array.isArray(quantity) ? quantity[0] : quantity, e.target.value, `${rowIndex}-${thisCol}`);
                      setUpdateValue(e.target.value);
                    }}
                    // onMouseEnter={(e) => {
                    //   const hasPromotion =
                    //     Array.isArray(quantitys)
                    //       ? quantitys[0]?.promotion_type != null
                    //       : quantitys?.promotion_type != null;

                    //   if (hasPromotion) {
                    //     const rect = e.target.getBoundingClientRect();
                    //     const promotionType = {
                    //       promotion_type: Array.isArray(quantitys)
                    //         ? quantitys[0]?.promotion_type
                    //         : quantitys?.promotion_type,
                    //       product_name: firstDateEntry?.product_name_tc,
                    //       product_date: nextDate
                    //     };

                    //     setTooltipPosition({
                    //       visible: true,
                    //       x: rect.right + 10,
                    //       y: rect.top,
                    //       content: promotionType,
                    //       promotionType: promotionType
                    //     });
                    //   }
                    // }}
                    // onMouseLeave={() => {
                    //   setTooltipPosition(prev => ({ ...prev, visible: false }));
                    // }}
                    onKeyDown={(e) => {

                      const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'];
                      const ctrlKey = isMac ? e.metaKey : e.ctrlKey;
                      if (ctrlKey && ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())) {
                        return; // Allow copy/paste/cut/select-all
                      }
                      if (!allowedKeys.includes(e.key)) e.preventDefault();
                      if (e.key === 'Tab') {
                        e.preventDefault();
                        const currentIndex = Number(e.target.dataset.index);
                        if (shouldOpenModal) {
                          setProductLabelModal(true);
                          setLabelData(filteredData);
                          setSubGroup(subGroupNameid);
                          setSubGroupName(customerSubGroupName);
                          setProductName(productName);
                          setLabelDate(nextDate);
                          setModalInputDisabled(isCurrentOrBeforeDate)
                        } else {
                          // Delay the focus to next input to allow DOM to stabilize
                          setTimeout(() => {
                            const nextInput = inputRefs.current[currentIndex + 1];
                            if (nextInput) { nextInput.focus(); nextInput.click() }
                          }, 0);
                        }
                      }
                    }}
                    pattern="[0-9]*"
                    inputMode="numeric"
                    disabled={loader || (isCurrentOrBeforeDate && !shouldOpenModal) || !checkEditPermission(rolesData?.permissions, 'direct_in_out')}
                    style={(loader || (isCurrentOrBeforeDate && !shouldOpenModal) || !checkEditPermission(rolesData?.permissions, 'direct_in_out')) ? { pointerEvents: isFirefox ? 'none' : 'auto', cursor: 'not-allowed' } : {}}
                  />
                </td>
              );
            });
          })}

      {/* //convertout block */}
      {productSalesHeader?.isRawProduct == 1  && typeof productSalesHeader?.finishedProductCodes === 'object' && Object.entries(productSalesHeader?.finishedProductCodes).map(([finish_pid, finish_code]) => {
        return (() => {
        const thisCol = columnCounter.value++;
        const key = `${rowIndex}-${thisCol}`;
        const isSelected = selectedCellsForSum[key] !== undefined;
        const convertOutQuantity = convertOutsObject[finish_pid] ?? '';
        const convertOutHistoryQuantity = convertOutsHistoryObject[finish_pid] ?? '';
        const convertOutInputValue = convertOutInputs?.[key];
        const displayConvertOutQuantity = convertOutInputValue ?? convertOutQuantity ?? '';
        const isThisCellSelected = selectedCell.row === rowIndex && selectedCell.col === thisCol;
        
        // Check if date is outside special period range for Type C
        const specialPeriod = productSalesHeader?.finishedProductSpecialPeriods?.[finish_pid];
        
        const fiveDaysAgo = new Date();
        fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 5);
        const formattedFiveDaysAgo = format(fiveDaysAgo, 'yyyy-MM-dd');

        const isTypeC = productSalesHeader.prepackTypes === 'C';
        const isOutsideSpecialRange = isTypeC && specialPeriod && (nextDate < specialPeriod.from || nextDate > specialPeriod.to);
        const isOlderThanFiveDays = isTypeC && nextDate <= formattedFiveDaysAgo;
        const isOutsideSpecialPeriod = isOutsideSpecialRange || isOlderThanFiveDays;
        
        const convertOutCellData = buildCellData({
          cellType: 'convert_out',
          date: formattedDate,
          module: 'prepack-inout',
          rawProductId: productId,
          finishedProductId: finish_pid,
          productName: productSalesHeader.productGroupId,
        });
        const hasRemarksConvertOut = cellHasRemarks(convertOutCellData, cellRemarks);
        
        return (
          <td tabIndex={0}
            onContextMenu={(e) => {
              handleCellContextMenu(e, convertOutCellData, setContextMenu, setSelectedCellData);
            }}
            onClick={() => {
              setSelectedCell({ row: rowIndex, col: thisCol });
            }}
            {...getCellDataAttributes(convertOutCellData)}
            className={`arrival-bg fw-bold arival-qty-ui convert-out-column remark-enabled-cell ${hasRemarksConvertOut ? 'cell-with-remark' : ''} ${isSelected ? "selected-for-sum" : ""} ${selectedCell.row === rowIndex || selectedCell.col === thisCol
            ? "highlight-border"
            : ""
            }`} 
          >
            {productSalesHeader.prepackTypes !== 'C' ? (
              <span className="ml-1">{convertOutQuantity}</span>
              ) : (<input
              type="text"
              value={isThisCellSelected && !isOutsideSpecialPeriod ? displayConvertOutQuantity : (convertOutHistoryQuantity !== '' ? `${convertOutHistoryQuantity} -> ${displayConvertOutQuantity}` : displayConvertOutQuantity)}
              onClick={() => {
                if (isOutsideSpecialRange) {
                  toast.warning('This date is outside of the special period for this product');
                  return;
                }
                if (isOlderThanFiveDays) {
                  toast.warning('This date is more than 5 days ago and cannot be edited');
                  return;
                }
                setGroupProductIds(productId);
              }}
              onChange={(e) => {
                const nextVal = e.target.value;
                setConvertOutInputs(prev => ({ ...prev, [key]: nextVal }));
                debouncedUpdateConvertOutData({
                  quantity: nextVal,
                  date: formattedDate,
                  raw_product_id: productId,
                  finished_product_id: finish_pid,
                }, `${rowIndex}-${thisCol}`);
              }}
              className="inout-tab"
              // disabled={isOutsideSpecialPeriod} // Disabled inputs don't fire events
              readOnly={isOutsideSpecialPeriod}
              style={isOutsideSpecialPeriod ? { backgroundColor: '#e9ecef', cursor: 'not-allowed' } : {}}
            />)}
          </td>
        );
      })()
  })}
          {/* //total qty cell block */}
        {(productSalesHeader?.isRawProduct == 1 || Object.keys(customerGroups).length !== 0) && (() => {
          const thisCol = columnCounter.value++;
          const key = `${rowIndex}-${thisCol}`;
          const isSelected = selectedCellsForSum[key] !== undefined;
          let totalQuantity = 0;
           
            Object.values(customerGroups).forEach(subGroupObject =>
              Object.values(subGroupObject).forEach(datesObject =>
                (datesObject[nextDate] || []).forEach(item => {
                  totalQuantity += Number(item.quantity) || 0;
                })
              )
            );
            if(productSalesHeader?.isRawProduct ==1 ){
              totalQuantity+=Number(totalConvertOutQuantity) || 0;
            }
          
          const handleClick = () => {
            const newSelection = getUpdatedSelection(
              selectedCellsForSum,
              rowIndex,
              thisCol,
              totalQuantity
            );
            setSelectedCellsForSum(newSelection);
            setSelectedCell({ row: rowIndex, col: thisCol });
          };

          const totalQtyCellData = buildCellData({
            cellType: 'total_qty',
            date: formattedDate,
            module: 'inout',
            productId: productId,
            productName: productSalesHeader?.productGroupId || 'N/A',
          });
          const hasRemarksTotalQty = cellHasRemarks(totalQtyCellData, cellRemarks);

          return (
            <td 
              onClick={handleClick} 
              onContextMenu={(e) => {
                handleCellContextMenu(e, totalQtyCellData, setContextMenu, setSelectedCellData);
              }}
              {...getCellDataAttributes(totalQtyCellData)}
              className={`sales-bg remark-enabled-cell ${hasRemarksTotalQty ? 'cell-with-remark' : ''} ${totalQuantity !== undefined ? 'show-sum-checkbox' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol
              ? "highlight-border"
              : ""
              }`}
            >
              <div className="flex ">
                {totalQuantity !== undefined && <div className="grouping">
                  <label className="checbox-cs relative cursor-pointer">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleClick();
                      }}
                      className="cursor-pointer absolute opacity-0 w-0 h-0"
                    />
                    <span className="checkmark" onClick={(e) => e.stopPropagation()}></span>
                  </label>{" "}
                  <span className="ml-1">{totalQuantity}</span>
                </div>}
              </div>
            </td>
          );
        })()}

    

        <>
          {/* //estimated stock cell td */}
          {(() => {
            const thisCol = columnCounter.value++;
            const shouldShowEstimate = estimatedStock !== null && estimatedStock !== undefined;
            const isForComparison = inventoryForDate?.estimated_for_comparison;
            
            const estimateStockCellData = buildCellData({
              cellType: 'estimate_stock',
              date: formattedDate,
              module: 'inout',
              productId: productId,
              productName: productSalesHeader?.productGroupId || 'N/A',
            });
            const hasRemarksEstimateStock = cellHasRemarks(estimateStockCellData, cellRemarks);
            
            return (
              <td 
                onClick={() => setSelectedCell({ row: rowIndex, col: thisCol })} 
                onContextMenu={(e) => {
                  handleCellContextMenu(e, estimateStockCellData, setContextMenu, setSelectedCellData);
                }}
                {...getCellDataAttributes(estimateStockCellData)}
                className={`estimate-stock remark-enabled-cell ${hasRemarksEstimateStock ? 'cell-with-remark' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}
                style={isForComparison ? { color: '#6c757d' } : {}}
              >
                {shouldShowEstimate && estimatedStock}
              </td>
            );
          })()}
          {/* //actual stock cell td */}
          {(() => {
            const thisCol = columnCounter.value++;
            const canEdit = onEditActualStock && nextDate <= format(new Date(), 'yyyy-MM-dd');
            return (
              <td
                onClick={() => {
                  setSelectedCell({ row: rowIndex, col: thisCol });
                  if (canEdit) {
                    onEditActualStock({
                      actual_stock: actualStock,
                      date: nextDate,
                      product_id: inventoryForDate?.product_id || productId,
                      refreshIds: productId,
                    });
                  }
                }}
                className={`stock-bg actual-stock not-check ${canEdit ? 'cursor-pointer' : ''} ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}
                style={canEdit ? { cursor: 'pointer' } : {}}
              >
                {(inventoryStatus === 'mixed' || inventoryStatus === 'actual') ? actualStock : (nextDate > format(new Date(), 'yyyy-MM-dd') ? '' : 'No Record')}
              </td>
            );
          })()}
          {/* //product stock cells td (only show on grouping open) */}
          {showGroupData === productId && (
            <>
              {selectedGroupProducts[productId] && (
                <>
                  {Object.values(selectedGroupProducts[productId])
                    .flat()
                    .filter((product, index, self) =>
                      index === self.findIndex(p => p.id === product.id)
                    )
                    .map((uniqueProduct) => {
                      const dateProducts = selectedGroupProducts[productId][nextDate] || [];
                      const matchedProduct = dateProducts.find(p => p.id === uniqueProduct.id);

                      return (
                        (() => {
                          const thisCol = columnCounter.value++; return (
                            <td
                              key={`stock-${productId}-${uniqueProduct.id}-${nextDate}`}
                              className={`stock-bg ${selectedCell.row === rowIndex || selectedCell.col === thisCol ? "highlight-border" : ""}`}
                            >
                              {matchedProduct?.actual_stock ?? ''}
                            </td>
                          );
                        })()
                      );
                    })}
                </>
              )}
            </>
          )}
        </>
      </React.Fragment>
    </>
  );
};
